module.exports = __webpack_public_path__ + "img/30524023000166.342fefb7.png";